<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Report Selection</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>

  <div class="center" [hidden]="!isLoading">
    <mat-spinner></mat-spinner>
  </div>
  <div class="search-options search-mat-column">
    <mat-form-field class="search-input">
      <input type="text" placeholder="{{Translate('Select Customer')}}" (input)="customerChanged($event)" matInput
             [matAutocomplete]="auto2" [(ngModel)]="selectedCustomer" name="customrer" required>
      <mat-autocomplete [(ngModel)]="customerId" #model_auto="ngModel" #auto2="matAutocomplete"
                        (optionSelected)="onSelectCustomer($event.option)">
        <mat-option [value]="customer.Title" *ngFor="let customer of _dropDownListsFiltered.customerList">
          {{ customer.Title}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="search-input">
      <mat-select (selectionChange)="jobsiteChanged($event)" [(ngModel)]="JobSiteId" name="jobsite1"
                  placeholder="{{Translate('Select Job Site')}}" required>
        <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
          {{ jobsite.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="sepbutton">
    <button class="white-button" mat-raised-button (click)="onCloseClick()">{{'Cancel' | translate | async}}</button>
    <a class="button button--primary" (click)="printPDF()" title="Click to get filtered data in CSV format.">
      <i class="material-icons button__icon">download</i><span class="button__text">PDF</span>
    </a>
  </div>
</div>
